import type { NftDetail } from '@dvb/common';

import { DescriptionBlock, Show } from '@dvb/ui';
import { Skeleton } from '@heroui/react';

import { Nft3DCard } from './Nft3DCard';

interface Props {
  nft?: NftDetail;
}

export function NftTopSection({ nft = undefined }: Props) {
  return (
    <>
      <Nft3DCard className="mb-10 mt-5" image={nft?.asset} size={256} />
      <div className="w-full overflow-hidden">
        <Show
          fallback={
            <div className="flex flex-col">
              <Skeleton className="bg-default-300 mx-auto mb-2 h-6 w-1/2 rounded-lg" />
              {Array.from(Array(4).keys()).map((i) => (
                <Skeleton
                  className="bg-default-300 mb-2 h-4 w-full rounded-lg"
                  key={i}
                />
              ))}
            </div>
          }
          when={!!nft}
        >
          <p className="mb-2 line-clamp-2 text-center text-xl font-bold">
            {nft?.name}
          </p>
          <DescriptionBlock text={nft?.description} />
          {/* <Spacer y={4} /> */}
        </Show>
      </div>
    </>
  );
}
